// src/pages/ChatBot/document-roles.ts
//
// Shared logic for the Documents tab's role-scoping surface. A document scoped
// to every one of the tenant's roles is functionally open to everyone, and the
// UI collapses that case to a single "Everyone" chip. This predicate is the one
// place that decides it, used by the staging table, the uploaded-doc table
// (DocumentsPanel), the inspector (DocumentInspectModal), and the access editor
// summary (DocumentAccessModal).

// True when a non-empty role scope names every tenant role — i.e. the scope is
// exhaustive and so equivalent to an unscoped, open-to-everyone document. False
// for an empty scope (which is unrestricted by a different code path), when the
// role list is unavailable, or when the tenant has no roles.
export function coversAllRoles(
  scopedRoleIDs: string[],
  roles: readonly { id: string }[] | null,
): boolean {
  return (
    scopedRoleIDs.length > 0 &&
    !!roles &&
    roles.length > 0 &&
    roles.every((role) => scopedRoleIDs.includes(role.id))
  );
}
